import { render, staticRenderFns } from "./modalCreateDirectory.vue?vue&type=template&id=1b21b18a&"
import script from "./modalCreateDirectory.vue?vue&type=script&lang=js&"
export * from "./modalCreateDirectory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports